import styles from "./LanguagePicker.module.scss";
import arrow from "../../assets/icons/arrow-down.svg";
import globe from "../../assets/icons/language.svg";
import japanese from "../../assets/icons/japanese-flag.svg";
import english from "../../assets/icons/english-flag.svg";
import french from "../../assets/icons/french-flag.svg";
import german from "../../assets/icons/german-flag.svg";
import spanish from "../../assets/spanish.jpg";
import globeWhite from "../../assets/icons/globe-white.svg";
import arrowWhite from "../../assets/icons/arrow-down-white.svg";
import cx from "classnames";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { trackEvent } from "../../utils/analytics";
import { EVENT_NAMES } from "../../types/event-names";

interface LanguagePickerProps {
  className?: string;
  border?: boolean;
}

const LanguagePicker: React.FC<LanguagePickerProps> = ({ className, border = false }) => {
  const { i18n } = useTranslation();
  const [isLanguagePickerOpen, setIsLanguagePickerOpen] = useState(false);
  const menuRef = useRef<HTMLDivElement | null>(null);

  const changeLanguage = (lng: string) => {
    trackEvent(EVENT_NAMES.LANGUAGE_CHANGED, {
      language: lng,
    });
    i18n?.changeLanguage(lng);
    setIsLanguagePickerOpen(false);
  };

  const toggleLanguagePicker = () => {
    setIsLanguagePickerOpen(!isLanguagePickerOpen);
  };

  useEffect(() => {
    const handleClickOutside = (event: any) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setIsLanguagePickerOpen(false);
      }
    };
    document.addEventListener("click", handleClickOutside);

    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    // Update the <html lang=""> attribute whenever language changes
    document.documentElement.lang = i18n.language;
  }, [i18n.language]);

  return (
    <div className={cx(styles.root, className)} onClick={toggleLanguagePicker} ref={menuRef}>
      {isLanguagePickerOpen ? (
        <div className={styles.root_active}>
          <img src={globeWhite} alt="globe" />
          <p className={styles.root_text}>{i18n.language.charAt(0).toUpperCase() + i18n.language.slice(1)}</p>
          <img src={arrowWhite} alt="arrow" />
        </div>
      ) : (
        <div className={border ? styles.root_disactiveBorder : styles.root_disactive}>
          <img src={globe} alt="globe" />
          <p className={styles.root_text}>{i18n.language.charAt(0).toUpperCase() + i18n.language.slice(1)}</p>
          <img src={arrow} alt="arrow" />
        </div>
      )}
      <div className={isLanguagePickerOpen ? styles.root_wrapper : ""}>
        {isLanguagePickerOpen && (
          <div className={styles.root_languageMenu}>
            <div className={styles.root_languageMenu_item} onClick={() => changeLanguage("en")}>
              <img src={english} alt="english" />
              <p>English</p>
            </div>
            <div className={styles.root_languageMenu_item} onClick={() => changeLanguage("fr")}>
              <img src={french} alt="french" />
              <p>Français</p>
            </div>
            <div className={styles.root_languageMenu_item} onClick={() => changeLanguage("de")}>
              <img src={german} alt="german" />
              <p>Deutsch</p>
            </div>
            <div className={styles.root_languageMenu_item} onClick={() => changeLanguage("ja")}>
              <img src={japanese} alt="japanese" />
              <p>日本語</p>
            </div>
            <div className={styles.root_languageMenu_item} onClick={() => changeLanguage("es")}>
              <img src={spanish} width={25} height={25} alt="spain" />
              <p>Español</p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default LanguagePicker;
